import { render, staticRenderFns } from "./PopularAddress.vue?vue&type=template&id=00618358"
import script from "./PopularAddress.vue?vue&type=script&lang=js"
export * from "./PopularAddress.vue?vue&type=script&lang=js"
import style0 from "./PopularAddress.vue?vue&type=style&index=0&id=00618358&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports